<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#f5a623">
  <defs>
    <style>.cls-1{display:none;}</style>
  </defs>
  <g id="transparent_box">
    <rect class="cls-1" width="32" height="32"/>
  </g>
  <g id="FILLED">
    <path d="M16,2,.24,29H31.72Zm0,20a1.5,1.5,0,1,1-1.53,1.49A1.48,1.48,0,0,1,16,22Zm-1-2V13h2v7Z"/>
  </g>
</svg>
